export default __webpack_public_path__ + "static/media/20_euros_account_type.88c5a00d.svg";